__turbopack_context__.v({
  "collectionSkeleton": "LoadingSkeleton-module-scss-module__g7j5aW__collectionSkeleton",
  "collectionsGrid": "LoadingSkeleton-module-scss-module__g7j5aW__collectionsGrid",
  "pulse": "LoadingSkeleton-module-scss-module__g7j5aW__pulse",
});
